<template>
	<div style="width: 100%;background: #fff;">
		<div class="d-flex p-2" style="align-items: center;">
			<div style="font-size: 14px;" class="mr-2">发生日期</div>
			<el-date-picker
			      v-model="value1"
			      type="daterange"
			      range-separator="至"
			      start-placeholder="开始日期"
			      end-placeholder="结束日期" size="mini" class="mr-2">
			    </el-date-picker>
			<el-button type="primary" size="mini">查询</el-button>
		</div>
		<div class="csss">
			<el-table :data="tableData" style="width: 100%" size="mini" :max-height="maxHeight">
				<el-table-column  prop="id" width="80" label="交易号"></el-table-column>
				<el-table-column  prop="name" label="发生日期"></el-table-column>
				<el-table-column  prop="name" label="客户"></el-table-column>
				<el-table-column  prop="name" label="供应商"></el-table-column>
				<el-table-column  prop="name" label="备注"></el-table-column>
				<el-table-column  prop="address" align="right" label="应收金额" sortable></el-table-column>
				<el-table-column  prop="address" align="right" label="核销金额" sortable></el-table-column>
				<el-table-column  prop="address" align="right" label="应收余额" sortable></el-table-column>
				<el-table-column  prop="address" align="right" label="逾期天数" sortable></el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			kon:'',
			value1: '',
			maxHeight:0,
			tableData: [
				{
					id:1,
					name: '默认账户',
					address: '0'
				},
				{
					id:2,
					name: '现金',
					address: '355215.02'
				},
				{
					id:3,
					name: '银行【对公】',
					address: '355215.02'
				},
				{
					id:4,
					name: '支付宝',
					address: '355215.02'
				},
				{
					id:5,
					name: '微信',
					address: '355215.02'
				},
				{
					id:6,
					name: '固定资产',
					address: '355214'
				},
				{
					id:7,
					name: '应收款',
					address: '355215.02'
				},
				{
					id:8,
					name: '应付款',
					address: '355215.02'
				},
				{
					id:9,
					name: '预收款',
					address: '355214'
				},
				{
					id:10,
					name: '预付款',
					address: '355215.02'
				},
				{
					id:11,
					name: '库存商品',
					address: '355215.02'
				},
				{
					id:12,
					name: '利润',
					address: '355214'
				},
				{
					id:10,
					name: '预付款',
					address: '355215.02'
				},
				{
					id:11,
					name: '库存商品',
					address: '355215.02'
				},
				{
					id:12,
					name: '利润',
					address: '355214'
				}
			],
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 234; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {},
};
</script>

<style>
</style>
